import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto, PagedResultRequestDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { OperatorResourceDto } from '../dtos/models';

@Injectable({
  providedIn: 'root',
})
export class OperatorResourceService {
  private readonly restService = inject(RestService);
  apiName = 'Default';
  

  getByVendorId = (input: PagedResultRequestDto, vendorId: number, searchString?: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<OperatorResourceDto>>({
      method: 'GET',
      url: `/api/app/operator-resource/by-vendor-id/${vendorId}`,
      params: { skipCount: input.skipCount, maxResultCount: input.maxResultCount, searchString },
    },
    { apiName: this.apiName,...config });
}